import * as React from "react";
import type { SVGProps } from "react";
const SvgBlipChanged = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><rect width={12} height={12} x={2} y={2} rx={3} transform="rotate(-45 8 8)" /></svg>;
export default SvgBlipChanged;